// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3BPeR","legacyBtn":"MutateMid_legacyBtn__3zUB5"};